import { combineReducers } from 'redux'
import signal from './signal'

const signalReducer = combineReducers({
  signal,
})

export default signalReducer
